import { Router } from '@angular/router';

import * as moment from 'moment';

import { AncillaryConfiguration } from 'src/shared/models/ancillary-configuration.model';
import { Constants } from 'src/shared/utilities/constants.util';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { TotalUOSShiftRecordService } from 'src/shared/services/shift-record-total-uos.service';
import { WorkflowPageComponent } from './workflow-page/workflow-page.component';
import { WorkflowUtilityService } from 'src/shared/services/workflow-utility.service';

export class TotalUosByBlock extends WorkflowPageComponent  {    
    public loadingRecords: boolean;
    public shiftBlocks: ShiftBlock[] = [];
    public shiftRecords: ShiftRecord[] = [];
    public workflowDate: string;

    constructor(
        protected _router: Router,
        protected _shiftBlockService: ShiftBlockService, 
        protected _totalUosShiftRecordService: TotalUOSShiftRecordService,
        protected _workflowUtilityService: WorkflowUtilityService) {
        super(_router);
    }

    public get ancillaryConfiguration(): AncillaryConfiguration {
        return this.shiftRecord.costCenter.ancillaryConfiguration;
    }

    public getShiftBlockControlName(shiftBlockId: number): string {
        return 'block-' + shiftBlockId;
    }

    public getShiftBlockLabel(shiftBlock: ShiftBlock): string {
        return this._workflowUtilityService.formatShiftTime(shiftBlock, this.workflowDate);
    }

    public getShiftRecordByShiftBlockId(shiftBlockId: number): ShiftRecord {
        return this.shiftRecords.find(s => s.shiftBlockId == shiftBlockId);
    } 

    public async initializeShiftRecords(useActuals: boolean) {
        this.loadingRecords = true;

        await this.setWorkflowDate(); 
        await this.setShiftBlocks();
        await this.setShiftRecords(useActuals);

        this.loadingRecords = false;
    }

    private getFormattedDate(shiftBlock: ShiftBlock) : string {
        return moment(this.workflowDate).hour(shiftBlock.startHour).format(Constants.FacilityTimeFormat);
    }

    private getWorkflowDates(): any[] {
        let workflowDates = [];

        this.shiftBlocks.forEach(block => {
            workflowDates.push(this.getFormattedDate(block));
        });  

        return workflowDates;
    }

    public hasShiftBlocks() {
        return MiscUtil.checkArray(this.shiftBlocks);
    }

    private async setShiftBlocks() {
        if (this.ancillaryConfiguration.enterUOSByBlock) {
            if (this.shiftRecord && this.shiftRecord.prevShiftRecord) {
                this.shiftBlocks = [ this.shiftRecord.prevShiftRecord.shiftBlock ];
            }            
        }
        else {
            let blocks = await this._shiftBlockService.loadList(this.shiftRecord.costCenterId, this.workflowDate);

            this.shiftBlocks = blocks.sort(sb => sb.startHour);
        }
    }

    private async setShiftRecords(useActuals: boolean) {
        let shiftBlockIds = this.shiftBlocks.map(s => s.id);
        let workflowDates = this.getWorkflowDates();

        if (useActuals) {
            this.shiftRecords = await this._totalUosShiftRecordService.getShiftRecordsForTotalUosActuals(shiftBlockIds, workflowDates);
        }
        else {
            this.shiftRecords = await this._totalUosShiftRecordService.getShiftRecordsForTotalUosReasons(shiftBlockIds, workflowDates)
        }
          
    }

    private async setWorkflowDate() {
        if (this.ancillaryConfiguration.enterUOSByBlock) {
            let previousShiftBlockDay = await this._shiftBlockService.getPreviousShiftBlockDay(this.shiftRecord.costCenterId, this.shiftRecord.workflowTimeFacility);

            if (previousShiftBlockDay) {
                this.workflowDate = moment(previousShiftBlockDay.timezoneAdjustedDate).format(Constants.FacilityTimeFormat);
            }
            else {
                this.workflowDate = moment(this.shiftRecord.workflowTimeFacility).format(Constants.FacilityTimeFormat);
            }            
        }
        else {
            let previousDate = await this._shiftBlockService.findPreviousUosWorkingDay(this.shiftRecord.costCenterId, this.shiftRecord.workflowTimeFacility);

            if (previousDate) {    
                this.workflowDate = moment(previousDate).format(Constants.FacilityTimeFormat)        
            }        
            else {        
                this.workflowDate = moment(this.shiftRecord.workflowTimeFacility).add(-1, 'day').format(Constants.FacilityTimeFormat);        
            } 
        }
    }
}